import React from 'react';
import PropTypes from 'prop-types';
import injectSheet from 'react-jss';
import { connect } from 'react-redux';
import { compose } from 'redux';
import theme from '../../styles/theme';
import Swiper from './Swiper';
import { isCurrentBreakpointAtLeast } from '../../selectors';

const SideScroller = ({ className, classes, ...rest }) => (
  <Swiper
    classNames={{
      wrapper: className,
      ...classes,
    }}
    {...rest}
  />
);

SideScroller.propTypes = {
  ...Swiper.propTypes,
  className: PropTypes.string,
};

SideScroller.defaultProps = {
  className: undefined,
  // eslint-disable-next-line react/default-props-match-prop-types
  slidesOffsetBefore: -theme.padding.gutter / 2,
  // eslint-disable-next-line react/default-props-match-prop-types
  slidesOffsetAfter: -theme.padding.gutter / 2,
};

const mapStateToProps = state => ({
  slidesOffsetAfter: isCurrentBreakpointAtLeast(state, 'xl')
    ? -theme.padding.gutter / 2
    : theme.padding.horizontal - theme.padding.gutter / 2,
});

const buttonStyle = {
  top: -48,
  position: 'absolute',
  [theme.breakpoints.down('sm')]: {
    '&:not(.container-button)': {
      display: 'none',
    },
  },
};

export default compose(
  connect(mapStateToProps),

  injectSheet({
    container: {
      [theme.breakpoints.down('lg')]: {
        // extend to the right-hand edge of the viewport
        width: `calc(100% + ${theme.padding.horizontal}px)`,
        marginRight: -theme.padding.horizontal,
      },
    },
    prev: {
      ...buttonStyle,
      right: 48,
    },
    next: {
      ...buttonStyle,
      right: 0,
    },
  }),
)(SideScroller);
